let TRPCError = function () {
  this.type = TRPCError.TRPCErrorType.UNKONWN;

  this.errInfo = '';
  this.code = 0;
  this.timeCST = 0;
  this.timeCRT = 0;
  this.timeSRT = 0;
  this.timeSST = 0;
  this.totalClient = 0;
  this.totalFCgi = 0;

  this.rawData = null;
};

TRPCError.TRPCErrorType = {
  // 未知出错
  UNKONWN: 9000,
  // 请求参数出错
  PARA: 9001,
  // 网络链路出错
  NETWORK: 9002,
  // 服务器返回http出错
  HTTP: 9003,
  // trpc出错
  TRPC: 9004,
  // 请求参数出错
  FCGI: 9005,
  // 获取body出错
  BODY: 9006,
  DECODE: 9007,
  PARA_EMPTY_REQUEST: 1,
  PARA_EMPTY_SERVER: 2,
  PARA_EMPTY_PB_DATA: 3,
  PARA_JSON_EXP: 4,
  ERRLogin: 10000,
  FCGI_RLOGIN_CONFILICT: 10001,
  FCGI_NEED_AUTH_FACE: 10002,
  FCGI_AUTH_FAIL: 10003,
  FCGI_LOGIN_FAIL: 10005,
};

TRPCError.prototype.getFcgiShowMessage = function () {
  if (
    this.type === TRPCError.TRPCErrorType.FCGI &&
    this.code > 0 &&
    this.errInfo.length
  ) {
    return this.errInfo;
  }
  return '';
};

export default TRPCError;